<div class="content">
    <a *ngFor="let item of socialItems" href="{{ item.link }}" target="_blank">
        <mat-icon class="icon" svgIcon="{{ item.icon }}"></mat-icon>
    </a>
</div>